/* Bright Ideas homepage (proposal, 31 Oct 2026): line-up, appliance finder,
   best-seller tabs, postcode checker, FAQ cards and entrance motion.
   Every part works as plain links and text without this script. */
(function () {
  'use strict';
  if (window.__biHp2) return;
  window.__biHp2 = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('bi-hp2-js');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(v) { return '£' + Number(v).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Entrances ---------- */
  function reveals() {
    var els = $$('[data-hp-reveal]');
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Never leave anything hidden if the observer is slow
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }

  /* ---------- Hero line-up ---------- */
  function lineup() {
    var hero = $('[data-hp-hero]');
    if (!hero) return;
    var row = $('[data-hp-row]', hero);
    var items = $$('[data-hp-item]', row);
    if (!items.length) return;
    var nameEl = $('[data-hp-name]', hero);
    var factEl = $('[data-hp-fact]', hero);
    var shopEl = $('[data-hp-shop]', hero);
    var findEl = $('[data-hp-find-current]', hero);
    var current = -1;
    var ticking = false;

    function setCurrent(i) {
      if (i === current) return;
      current = i;
      var it = items[i];
      hero.style.backgroundColor = it.getAttribute('data-tint');
      nameEl.textContent = it.getAttribute('data-name');
      factEl.textContent = it.getAttribute('data-fact');
      shopEl.setAttribute('href', it.getAttribute('href'));
      shopEl.textContent = 'Shop ' + it.getAttribute('data-name').toLowerCase();
      if (findEl) {
        var t = it.getAttribute('data-type');
        findEl.hidden = !t;
        findEl.setAttribute('data-hp-find', t || '');
      }
      items.forEach(function (el, j) { el.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }

    function update() {
      ticking = false;
      var r = row.getBoundingClientRect();
      var mid = r.left + r.width / 2;
      var best = 0, bestD = Infinity;
      items.forEach(function (el, i) {
        var b = el.getBoundingClientRect();
        var d = (b.left + b.width / 2 - mid) / b.width;
        var ad = Math.abs(d);
        if (ad < bestD) { bestD = ad; best = i; }
        var k = Math.min(ad, 3);
        if (!reduceMotion) {
          el.style.transform = 'scale(' + (1 - 0.18 * k).toFixed(3) + ') translateY(' + (k % 2 ? -1.2 : 1.2) * Math.min(k, 1) + 'rem)';
          el.style.filter = 'brightness(' + (1 - 0.08 * k).toFixed(3) + ')';
        }
        el.classList.toggle('is-near', ad < 0.5);
      });
      setCurrent(best);
    }

    row.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);

    items.forEach(function (el, i) {
      el.addEventListener('click', function (e) {
        if (i !== current) {
          e.preventDefault();
          el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    row.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var n = Math.max(0, Math.min(items.length - 1, current + (e.key === 'ArrowRight' ? 1 : -1)));
      items[n].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      items[n].focus({ preventScroll: true });
    });

    // Start with the first item centred
    var start = parseInt(hero.getAttribute('data-start') || '0', 10);
    var first = items[start] || items[0];
    row.scrollLeft = first.offsetLeft - (row.clientWidth - first.offsetWidth) / 2;
    update();
  }

  /* ---------- Appliance finder ---------- */
  var PEOPLE = {
    id: 'people',
    q: 'How many people live in your home?',
    options: [
      { v: 'small', label: '1 or 2 people', sub: 'A 7 to 8kg drum is plenty', kg: [0, 8] },
      { v: 'mid', label: '3 or 4 people', sub: 'Look for 8 to 9kg', kg: [8, 9] },
      { v: 'big', label: '5 or more', sub: '10kg or bigger saves extra loads', kg: [10, 99] },
      { v: 'any', label: 'Not sure', sub: 'Show me every size' }
    ]
  };
  var BUDGET = {
    id: 'budget',
    q: 'What would you like to spend?',
    options: [
      { v: 'b1', label: 'Up to £400', max: 400 },
      { v: 'b2', label: '£400 to £800', min: 400, max: 800 },
      { v: 'b3', label: 'Over £800', min: 800 },
      { v: 'any', label: 'Show me everything' }
    ]
  };
  function fit(ids) {
    return {
      id: 'fit',
      q: 'Freestanding or built in?',
      options: [
        { v: 'free', label: 'Freestanding', sub: 'Stands on its own in a standard gap', col: ids[0] },
        { v: 'built', label: 'Built in', sub: 'Hidden behind a kitchen cupboard door', col: ids[1] }
      ]
    };
  }

  var TYPES = {
    washing: {
      name: 'washing machine',
      steps: [PEOPLE, fit(['freestanding-washing-machines', 'integrated-washing-machines']), BUDGET]
    },
    dryer: {
      name: 'tumble dryer',
      steps: [
        PEOPLE,
        {
          id: 'kind',
          q: 'Which kind of tumble dryer?',
          options: [
            { v: 'hp', label: 'Heat pump', sub: 'Costs the least to run', col: 'freestanding-tumble-dryers', re: /heat\s*pump/i },
            { v: 'cond', label: 'Condenser', sub: 'No vent hose needed', col: 'freestanding-tumble-dryers', re: /condenser/i, not: /heat\s*pump/i },
            { v: 'vent', label: 'Vented', sub: 'Needs a hose out of a window or wall', col: 'freestanding-tumble-dryers', re: /vent/i },
            { v: 'built', label: 'Built in', sub: 'Hidden behind a cupboard door', col: 'integrated-tumble-dryers' }
          ]
        },
        BUDGET
      ]
    },
    washerdryer: {
      name: 'washer dryer',
      steps: [PEOPLE, fit(['washer-dryers', 'integrated-washer-dryers']), BUDGET]
    },
    fridge: {
      name: 'fridge freezer',
      steps: [
        {
          id: 'kind',
          q: 'What sort of fridge freezer?',
          options: [
            { v: 'std', label: 'Standard upright', sub: 'Most fit a 55 to 60cm space', col: 'fridge-freezers', not: /under\s*-?counter/i },
            { v: 'american', label: 'American style', sub: 'Wide, often with water and ice', col: 'american-style-fridge-freezers' },
            { v: 'under', label: 'Under the counter', sub: 'Fits below a worktop', col: 'fridge-freezers', re: /under\s*-?counter/i },
            { v: 'built', label: 'Built in', sub: 'Hidden behind cupboard doors', col: 'integrated-fridge-freezers' }
          ]
        },
        {
          id: 'split',
          q: 'Fridge or freezer: which needs more space?',
          onlyIf: { kind: ['std', 'built'] },
          options: [
            { v: 'fridge', label: 'More fridge', sub: 'A 70/30 split', re: /70\s*\/\s*30/ },
            { v: 'even', label: 'About even', sub: '50/50 or 60/40', re: /(50\s*\/\s*50|60\s*\/\s*40)/ },
            { v: 'any', label: 'Not fussed' }
          ]
        },
        BUDGET
      ]
    },
    dishwasher: {
      name: 'dishwasher',
      steps: [
        {
          id: 'size',
          q: 'Full size or slimline?',
          options: [
            { v: 'full', label: 'Full size (60cm)', sub: 'Around 12 to 15 place settings' },
            { v: 'slim', label: 'Slimline (45cm)', sub: 'For smaller kitchens' }
          ]
        },
        {
          id: 'fit',
          q: 'Freestanding or built in?',
          options: [
            { v: 'free', label: 'Freestanding', sub: 'Stands on its own' },
            { v: 'built', label: 'Built in', sub: 'Hidden behind a cupboard door' }
          ]
        },
        BUDGET
      ],
      collection: function (s) {
        if (s.size === 'slim') return s.fit === 'built' ? 'integrated-slimline-dishwasher' : 'slimline-dishwasher';
        return s.fit === 'built' ? 'integrated-dishwashers' : 'freestanding-dishwashers';
      }
    },
    cooker: {
      name: 'cooker',
      steps: [
        {
          id: 'kind',
          q: 'What kind of cooker?',
          options: [
            { v: 'elec', label: 'Electric cooker', sub: 'Freestanding, 50 to 60cm wide', col: 'electric-cookers' },
            { v: 'gas', label: 'Gas or dual fuel cooker', sub: 'Gas hob, freestanding', col: 'gas-and-duel-fuel-cookers' },
            { v: 'range-e', label: 'Electric range cooker', sub: 'Wide, with two or more ovens', col: 'electric-range-cookers' },
            { v: 'range-g', label: 'Dual fuel range cooker', sub: 'Gas hob, electric ovens', col: 'gas-and-duel-fuel-range-cookers' },
            { v: 'oven', label: 'Built-in oven', sub: 'Fits into a kitchen unit', col: 'integrated-ovens' }
          ]
        },
        BUDGET
      ]
    }
  };

  var cache = {};
  function loadCollection(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (d) { return d.products || []; });
    }
    return cache[handle];
  }

  function kgOf(title) {
    var m = String(title).match(/(\d{1,2}(?:\.\d)?)\s?kg/i);
    return m ? parseFloat(m[1]) : null;
  }

  function finder() {
    var root = $('[data-hp-finder]');
    if (!root) return;
    var stepsEl = $('[data-hp-steps]', root);
    var crumbsEl = $('[data-hp-crumbs]', root);
    var barEl = $('[data-hp-bar]', root);
    var resultsEl = $('[data-hp-results]', root);
    var typeStep = $('[data-hp-typestep]', root);
    var titles = {};
    $$('[data-type]', typeStep).forEach(function (b) {
      titles[b.getAttribute('data-type')] = b.getAttribute('data-title') || b.getAttribute('data-type');
    });
    var state = null;

    function chosen(step) {
      return step.options.filter(function (o) { return o.v === state.answers[step.id]; })[0];
    }

    function visibleSteps() {
      var cfg = TYPES[state.type];
      return cfg.steps.filter(function (st) {
        if (!st.onlyIf) return true;
        return Object.keys(st.onlyIf).every(function (k) { return st.onlyIf[k].indexOf(state.answers[k]) > -1; });
      });
    }

    function renderCrumbs() {
      var bits = [titles[state.type]];
      visibleSteps().forEach(function (st) {
        var o = chosen(st);
        if (o) bits.push(o.label);
      });
      crumbsEl.innerHTML = bits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('');
      barEl.hidden = false;
    }

    function focusQ(el) {
      var q = $('.bi-hp2-step__q', el) || el;
      q.setAttribute('tabindex', '-1');
      q.focus({ preventScroll: true });
    }

    function next() {
      renderCrumbs();
      var st = visibleSteps().filter(function (s) { return !state.answers[s.id]; })[0];
      if (!st) return showResults();
      typeStep.hidden = true;
      resultsEl.hidden = true;
      stepsEl.hidden = false;
      stepsEl.innerHTML =
        '<div class="bi-hp2-step"><p class="bi-hp2-step__q">' + esc(st.q) + '</p><div class="bi-hp2-choices">' +
        st.options.map(function (o) {
          return '<button type="button" class="bi-hp2-choice" aria-pressed="false" data-v="' + esc(o.v) + '"><strong>' + esc(o.label) + '</strong>' +
            (o.sub ? '<span>' + esc(o.sub) + '</span>' : '') + '</button>';
        }).join('') + '</div></div>';
      $$('.bi-hp2-choice', stepsEl).forEach(function (b) {
        b.addEventListener('click', function () {
          b.setAttribute('aria-pressed', 'true');
          state.answers[st.id] = b.getAttribute('data-v');
          setTimeout(next, reduceMotion ? 0 : 120);
        });
      });
      focusQ(stepsEl);
    }

    function collectionFor() {
      var cfg = TYPES[state.type];
      if (cfg.collection) return cfg.collection(state.answers);
      var handle = null;
      visibleSteps().forEach(function (st) { var o = chosen(st); if (o && o.col) handle = o.col; });
      return handle;
    }

    function matches(p) {
      var ok = p.variants.some(function (v) { return v.available; }) &&
        p.tags.indexOf('out-of-stock') === -1 &&
        parseFloat(p.variants[0].price) > 0;
      if (!ok) return false;
      return visibleSteps().every(function (st) {
        var o = chosen(st);
        if (!o || st === BUDGET) return true;
        if (o.re && !o.re.test(p.title)) return false;
        if (o.not && o.not.test(p.title)) return false;
        if (o.kg) {
          var kg = kgOf(p.title);
          if (kg === null || kg < o.kg[0] || kg > o.kg[1]) return false;
        }
        return true;
      });
    }

    function inBudget(p) {
      var o = chosen(BUDGET);
      if (!o) return true;
      var price = parseFloat(p.variants[0].price);
      if (o.min && price < o.min) return false;
      if (o.max && price > o.max) return false;
      return true;
    }

    // The same compact data the shop's product cards carry, so the homepage
    // card snippet (bi-hp2-cards) can add its benefit line, bubbles and stickers
    function cardData(p) {
      var v = p.variants[0] || {};
      var specs = [];
      String(p.body_html || '').split(/<li[^>]*>/i).slice(1).forEach(function (part) {
        var line = part.split(/<\/li>/i)[0].replace(/<[^>]+>/g, '').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
        if (line && line.length < 100) specs.push(line);
      });
      return {
        id: p.id, h: p.handle, u: '/products/' + p.handle, t: p.title, v: p.vendor, ty: p.product_type,
        tg: p.tags || [], p: Math.round(parseFloat(v.price || 0) * 100),
        c: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
        a: !!v.available, vid: v.id || 0, vc: (p.variants || []).length, s: specs
      };
    }

    function card(p) {
      var img = p.images && p.images[0] ? p.images[0].src : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=500';
      var price = parseFloat(p.variants[0].price);
      var data = cardData(p);
      var desc = data.s.length < 5 ? String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 600) : '';
      var url = '/products/' + esc(p.handle);
      return '<li class="bi-hp2-result"' + (desc ? ' data-desc="' + esc(desc) + '"' : '') + '>' +
        '<div class="bi-card bi-hp2-result__card" data-product="' + esc(JSON.stringify(data)) + '">' +
        '<a href="' + url + '" class="bi-hp2-result__field" tabindex="-1" aria-hidden="true">' + (img ? '<img class="bi-hp2-cut" src="' + esc(img) + '" alt="" width="500" height="500" loading="lazy">' : '') + '</a>' +
        '<span class="bi-hp2-result__brand">' + esc(p.vendor) + '</span>' +
        '<h3 class="bi-card__title bi-hp2-result__title"><a href="' + url + '" style="text-decoration:none">' + esc(p.title) + '</a></h3>' +
        '<ul class="bi-card__chips" role="list" aria-label="Key features"></ul>' +
        '<span class="bi-hp2-result__price">' + money(price) + '</span>' +
        '<span class="bi-hp2-result__fit">Delivery, fitting and removal available</span>' +
        '<a class="bi-hp2-btn bi-hp2-btn--ink" href="' + url + '">View and add fitting<span class="bi-hp2-visually-hidden"> for ' + esc(p.title) + '</span></a>' +
        '</div></li>';
    }

    function showResults() {
      var handle = collectionFor();
      stepsEl.hidden = true;
      resultsEl.hidden = false;
      resultsEl.innerHTML = '<p class="bi-hp2-loading" role="status">Finding the best matches…</p>';
      var name = TYPES[state.type].name;
      loadCollection(handle).then(function (all) {
        var fits = all.filter(matches);
        var picks = fits.filter(inBudget);
        var note = 'Our top picks, in the order we recommend them. Every one can be delivered and fitted by our own team.';
        if (!picks.length && fits.length) {
          picks = fits.slice().sort(function (a, b) {
            return parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price);
          });
          note = 'Nothing quite matches that budget right now, so here are the closest. Call us and we’ll check what we can get in.';
        }
        var html;
        if (!picks.length) {
          html = '<p class="bi-hp2-results__head" tabindex="-1">We’ll find the right ' + esc(name) + ' for you</p>' +
            '<p class="bi-hp2-results__note">Nothing online matches all of that at the moment, but we can order most models in. Call the shop or send us your answers and we’ll come back with options.</p>' +
            '<div class="bi-hp2-results__more"><a class="bi-hp2-btn" href="tel:01937585646">Call 01937 585646</a><a class="bi-hp2-btn bi-hp2-btn--paper" href="/pages/enquiry-page">Send an enquiry</a>' +
            (handle ? '<a class="bi-hp2-textlink" href="/collections/' + esc(handle) + '">Browse them all</a>' : '') + '</div>';
        } else {
          html = '<p class="bi-hp2-results__head" tabindex="-1">' + picks.length + ' ' + esc(name) + (picks.length === 1 ? '' : 's') + ' to suit you</p>' +
            '<p class="bi-hp2-results__note">' + note + '</p>' +
            '<ul class="bi-hp2-results__grid bi-hp2-dress" role="list">' + picks.slice(0, 3).map(card).join('') + '</ul>' +
            '<div class="bi-hp2-results__more"><a class="bi-hp2-btn" href="/collections/' + esc(handle) + '">See all ' + all.length + ' in this range</a>' +
            '<a class="bi-hp2-textlink" href="tel:01937585646">Rather talk it through? Call 01937 585646</a></div>';
        }
        resultsEl.innerHTML = html;
        // Let the shop's card script fill the spec chips, then add bubbles and stickers
        setTimeout(function () { if (window.__biHp2Dress) window.__biHp2Dress(); }, 200);
        focusQ(resultsEl.firstElementChild);
        resultsEl.firstElementChild.focus({ preventScroll: true });
      }).catch(function () {
        resultsEl.innerHTML = '<p class="bi-hp2-results__head">We couldn’t load the matches just now</p>' +
          '<div class="bi-hp2-results__more"><a class="bi-hp2-btn" href="/collections/' + esc(handle) + '">Browse the range</a><a class="bi-hp2-textlink" href="tel:01937585646">Call 01937 585646</a></div>';
      });
    }

    function start(type, scroll) {
      if (!TYPES[type]) return;
      state = { type: type, answers: {} };
      $$('[data-type]', typeStep).forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-type') === type); });
      next();
      if (scroll) root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    function reset() {
      state = null;
      stepsEl.hidden = true;
      resultsEl.hidden = true;
      barEl.hidden = true;
      typeStep.hidden = false;
      $$('[data-type]', typeStep).forEach(function (b) { b.classList.remove('is-on'); });
      focusQ(typeStep);
    }

    $$('[data-type]', typeStep).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        start(b.getAttribute('data-type'), false);
      });
    });
    $('[data-hp-reset]', root).addEventListener('click', reset);

    // "Help me choose" links anywhere on the page
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-hp-find]');
      if (!a) return;
      var t = a.getAttribute('data-hp-find');
      e.preventDefault();
      if (t) start(t, true);
      else root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- Best-seller tabs ---------- */
  function tabs() {
    $$('[data-hp-tabs]').forEach(function (wrap) {
      var tabs = $$('[role="tab"]', wrap);
      function select(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', String(on));
          x.tabIndex = on ? 0 : -1;
          document.getElementById(x.getAttribute('aria-controls')).hidden = !on;
        });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* ---------- Postcode checker ---------- */
  function checker() {
    var form = $('[data-hp-check]');
    if (!form) return;
    var input = $('input', form);
    var out = $('[data-hp-check-result]', form.parentNode);
    var shopLat = parseFloat(form.getAttribute('data-lat'));
    var shopLng = parseFloat(form.getAttribute('data-lng'));
    var free = parseFloat(form.getAttribute('data-free'));
    var area = parseFloat(form.getAttribute('data-area'));
    var phone = form.getAttribute('data-phone');
    var sameDay = '<p>In-stock appliances are often delivered the same day. Anything we order in usually arrives in 2 to 3 days.</p>';

    function miles(a, b, c, d) {
      var R = 3958.8, toR = Math.PI / 180;
      var dLat = (c - a) * toR, dLng = (d - b) * toR;
      var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a * toR) * Math.cos(c * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(h));
    }

    function show(cls, html) {
      out.className = 'bi-hp2-check__result' + (cls ? ' ' + cls : '');
      out.innerHTML = html;
      out.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pc = input.value.replace(/\s+/g, '').toUpperCase();
      if (!/^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(pc)) {
        show('', '<strong>Please enter a full postcode</strong><p>For example LS22 6NR. Or call us on <a href="tel:' + phone.replace(/\s/g, '') + '">' + phone + '</a>.</p>');
        return;
      }
      show('', '<p role="status">Checking…</p>');
      fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(pc))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d || d.status !== 200 || !d.result) throw new Error('nf');
          var res = d.result;
          var place = res.parish ? res.parish.replace(/,.*$/, '') : (res.admin_district || res.postcode);
          var m = miles(shopLat, shopLng, res.latitude, res.longitude);
          var about = 'About ' + (m < 1 ? 'a mile' : Math.round(m) + ' miles') + ' from our North Street shop.';
          var tel = '<a href="tel:' + phone.replace(/\s/g, '') + '">' + phone + '</a>';
          if (m <= free * 0.9) {
            show('is-free', '<strong>Free delivery to ' + esc(place) + '</strong><p>' + about + ' You’re inside our free ' + free + '-mile delivery area.</p>' + sameDay);
          } else if (m <= free * 1.2) {
            show('', '<strong>You’re right on the edge of our free area</strong><p>' + about + ' Call ' + tel + ' and we’ll confirm whether delivery to ' + esc(place) + ' is free or £30.</p>' + sameDay);
          } else if (m <= area) {
            show('', '<strong>Delivery to ' + esc(place) + ' is £30</strong><p>' + about + ' Delivery is free within ' + free + ' miles of the shop and £30 across the rest of our area.</p>' + sameDay);
          } else {
            show('', '<strong>' + esc(place) + ' may be outside our usual area</strong><p>' + about + ' Call ' + tel + ' and we’ll tell you what we can do.</p>');
          }
        })
        .catch(function () {
          show('', '<strong>We couldn’t find that postcode</strong><p>Check it and try again, or call us on <a href="tel:' + phone.replace(/\s/g, '') + '">' + phone + '</a>.</p>');
        });
    });
  }

  /* ---------- FAQ cards: one open at a time ---------- */
  function faq() {
    $$('[data-hp-faq]').forEach(function (list) {
      var qs = $$('.bi-hp2-qcard__q', list);
      qs.forEach(function (q) {
        q.addEventListener('click', function () {
          var open = q.getAttribute('aria-expanded') === 'true';
          qs.forEach(function (o) {
            o.setAttribute('aria-expanded', 'false');
            document.getElementById(o.getAttribute('aria-controls')).hidden = true;
          });
          if (!open) {
            q.setAttribute('aria-expanded', 'true');
            document.getElementById(q.getAttribute('aria-controls')).hidden = false;
          }
        });
      });
    });
  }

  function init() {
    reveals();
    lineup();
    finder();
    tabs();
    checker();
    faq();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
